<template>
  <div ref="backdrop">
    <div
      class="main-modal"
      data-scroll-lock-scrollable
      tabindex="-1"
      role="dialog"
      @click="onClickBackdrop"
    >
      <div ref="modal" class="modal-card">
        <header class="modal-card-head">
          <div class="titles">
            <slot name="header" />
          </div>

          <span v-if="!hideCloseButton" class="close" aria-label="close" @click="close">
            <UiBaseIcon width="14px" height="14px" color="#9DA9B8" icon-name="close" />
          </span>
        </header>

        <section class="modal-card-body">
          <slot name="content" />
        </section>

        <footer class="modal-card-foot">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { disablePageScroll, enablePageScroll } from 'scroll-lock'
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

export default {
  name: 'UiModal',
  components: { UiBaseIcon },
  props: {
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    closeOnOverlay: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    disablePageScroll()

    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    enablePageScroll()

    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    close() {
      this.$emit('update:show', false)
      this.$emit('close', true)
    },
    onClickBackdrop($event) {
      const isBackdrop = $event && $event.target.parentElement === this.$refs.backdrop
      if (this.closeOnOverlay && isBackdrop) {
        this.close()
      }
    },
    handleKeydown($event) {
      if ($event.keyCode === 27) {
        this.close()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: rgba(0, 0, 0, 0.4);

  @include media_tablet {
    padding: 16px;
  }
}

.modal-card {
  z-index: 9999;
  display: block;
  width: 100%;
  min-width: 320px;
  padding: rem(20px);
  background: #fff;
  border-radius: 0;

  @include media_tablet {
    margin: 20px auto;

    @include border-radius(5px);
  }

  &-head {
    border: none;
    border-radius: 0;

    @include createFlex(flexbox, nowrap, row, space-between, flex-start, flex-start);
  }

  &-body {
    position: relative;
    margin: rem(24px) 0 0 0;
  }

  &-foot {
    margin: rem(24px) 0 0 0;
    background: #fff;
    border-radius: 0;

    .button {
      &:not(:last-child) {
        margin-right: 5px;

        @media screen and (min-width: 345px) {
          margin-right: 20px;
        }
      }
    }
  }

  .titles {
    font-weight: bold;

    @include createFlex(flexbox, nowrap, column, flex-start, stretch, stretch);

    .modal-card-title {
      font-size: rem(14px);
      line-height: rem(14px);
      color: #343434;
    }

    .modal-card-subtitle {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
      color: rgba(52, 52, 52, 0.8);
    }
  }
}

.is-small {
  .modal-card {
    width: 100%;
    min-height: 100%;

    @include media_tablet {
      width: 320px;
      min-height: auto;
    }
  }
}

.close {
  &:hover {
    cursor: pointer;
  }
}
</style>
